module.exports = "/static/media/howToImage4.1a7102cc.jpg";